<template>
  <div>
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>



<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "@/css/videoplayer.css";
import "videojs-vjsdownload";
import "videojs-vjsdownload/dist/videojs-vjsdownload.css";


import "videojs-contrib-quality-levels";
//import "@samueleastdev/videojs-dash-hls-bitrate-switcher";
import "videojs-hls-quality-selector";

import "videojs-mux";

import * as fb from "./../firebase";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    eventname: {
      type: String,
      default() {
        return {};
      },
    },
    uid: {
      type: String,
      default() {
        return {};
      },
    },
    currentSrcLang: {
      type: String,
      default() {
        return {};
      },
    },
    audioLanguageHint: {
      type: String,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      player: null,
      watchingLogInterval: null,
      currentAudioTrackLanguageCode: null,
      audioTracks: null,
      firstPlay: true,
    };
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options);
    /*this.player.dashHlsBitrateSwitcher({
      showInfo: false,
    });*/
    this.player.hlsQualitySelector({
      displayCurrentQuality: false,
    });
    this.player.responsive(true);
    this.player.on("playing", () => {
      for (var i = 0; i < this.player.audioTracks().length; i++) {
        var track = this.player.audioTracks()[i];
        if (this.firstPlay && this.player.audioTracks()[i].language == this.audioLanguageHint) {
          console.log("hint: "+this.audioLanguageHint)
          this.player.audioTracks()[i].enabled = true
          console.log("enabling language from hint:")
          console.log(this.player.audioTracks()[i])
          this.firstPlay = false
        }
        if (track.enabled) {
          this.currentAudioTrackLanguageCode = track.language;
        }

      }
      this.logWatching();
      if (!this.watchingLogInterval) {
        this.watchingLogInterval = setInterval(() => {
          this.logWatching();
        }, 10000);
        //Set currentAudioTrack Language code
      }
    });
    this.player.on(["pause", "waiting", "ended", "stalled", "error"], () => {
      this.watchingLogInterval ? clearInterval(this.watchingLogInterval) : "";
      this.watchingLogInterval = null;
    });

    this.player.audioTracks().addEventListener("change", () => {
      for (var i = 0; i < this.player.audioTracks().length; i++) {
        var track = this.player.audioTracks()[i];

        if (track.enabled) {
          this.currentAudioTrackLanguageCode = track.language;
          this.player.paused() ? null : this.logWatching();
          return;
        }
      }
    });
  },
  methods: {
    logWatching() {
      //console.log("log watching");
      let last_heartbeat_ts = Math.floor(Date.now() / 1000);

      //last log
      fb.db
        .collection("tenants")
        .doc(this.$route.params.tenantname)
        .collection("events")
        .doc(this.eventname)
        .collection("viewers")
        .doc(this.uid)
        .set(
          {
            last_heartbeat_ts: last_heartbeat_ts,
            last_src_lang: this.currentSrcLang,
            last_audio_track_language_code: this.currentAudioTrackLanguageCode,
            updated_at: fb.serverTs,
          },
          { merge: true }
        )
        .then(function () {
          //console.log(Math.floor(Date.now() / 1000));
        })
        .catch(function (error) {
          console.log("Error updating document: ", error);
        });

      //history log
      fb.db
        .collection("tenants")
        .doc(this.$route.params.tenantname)
        .collection("events")
        .doc(this.eventname)
        .collection("viewers")
        .doc(this.uid)
        .collection("history")
        .doc(last_heartbeat_ts.toString())
        .set(
          {
            last_heartbeat_ts: last_heartbeat_ts,
            last_src_lang: this.currentSrcLang,
            last_audio_track_language_code: this.currentAudioTrackLanguageCode,
            updated_at: fb.serverTs,
          },
          { merge: true }
        )
        .then(function () {
          //
        })
        .catch(function (error) {
          console.log("Error updating document: ", error);
        });

      //google analytics log
      fb.analytics.logEvent("video_event", {
        eventAction: "watching",
        videoSrc: this.player.src,
        videoTime: Math.floor(
          this.player.currentProgramDateTime || this.player.currentTime
        ),
      });
    },
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.watchingLogInterval ? clearInterval(this.watchingLogInterval) : "";
    }
  },
};
</script>